
(function () {  // Private scope

  var Widgets     = [];
  var Controllers = [];

